import React from 'react' 
import { useEffect, useState } from "react";
import { getFaculty } from "../Service/Api";

const NonTeachingStaff = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]); 
  useEffect(() => {
      const fetchData = async () => {
          try {
              const readingData1 = await getFaculty();
              const readingData = readingData1.filter((item) => item.category ==='NonTeaching');
              // Check if readingData is an array
              if (Array.isArray(readingData)) {
                  // Sort the data by class as numbers
                  const sortedData = readingData.sort((a, b) => {
                      return parseInt(a.order) - parseInt(b.order);
                  });

                  setData(sortedData);
                  setFilteredData(sortedData); // Initially display all sorted data
              } else {
                  console.error('Error: readingData is not an array');
              }
          } catch (error) {
              console.error('Error fetching data:', error);
          }
      };
      fetchData();
  }, []);
   return (
    <>
    {filteredData.length > 0 ? (
      filteredData.map((item, index) => (
<tr>
<td>{index + 1}</td>
<td>{item.name}</td>
<td>{item.designation}</td>
  <td>{item.qualification} </td>  
</tr> 
))
) : (
<tr>
<td>1</td>
<td>Name</td>
<td>Designation</td>
 <td>Qualification </td>  
</tr> 
)}
     {  /*  <tr><td>1</td><td>Mr. Clyde Romaldo Torres</td><td>Accountant</td><td>B.com</td></tr>
    <tr> <td>2</td><td>Ms. Aldrina Pereira</td><td>Accountant</td><td>B.com</td></tr> 
    <tr> <td>3</td><td>Ms. Rosy Gurung</td><td>Clerk</td><td>B.A, M.A, LLB</td></tr> 
    <tr> <td>4</td><td>Mrs. Jashandeep Kaur </td>  	<td> Nurse	</td>   <td>	B.sc </td></tr> */}

  </>
  )
}

export default NonTeachingStaff
